//import './publicPath';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import userLoader from "./middleware/userLoader.js";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ErrorPage2 } from "./error-page";

const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter([
  {
    path: "/",
    element: <ErrorPage2 />,
    errorElement: <ErrorPage2 />,
  },
  {
    path: "/:username",
    element: <App />,
    loader: userLoader,
    errorElement: <ErrorPage2 />,
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
//   <App />

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
